// extracted by mini-css-extract-plugin
export default {"btn":"LightBtn_btn__bf7r9","head":"LightBtn_head__l9VxA","btn1":"LightBtn_btn1__08SOW","head1":"LightBtn_head1__rVN8C"};